import React, {Component} from 'react';
import Navbar from "../Navbar/Navbar";
import './Switch.css';

export default class Switch extends Component {
    state={
      myAss:[],
        newSwitchName: ''
    };
    componentDidMount() {
        this.fetchData();
    }

    clickOnHandler=(e)=>{
        console.log(e.target.value);
        fetch(`https://py-switches.herokuapp.com/graphql?query=mutation{UpdateSwitch(switchInput:{name:"${e.target.value}",state:${true},uuid:"${localStorage.getItem('uuid')}"}){
        name
        state
        }}`,{method: 'POST'}).then(fetchRsp=>{

            fetchRsp.json().then(jsnrsp=>{
                console.log(jsnrsp);
                this.setState({myAss:jsnrsp.data.UpdateSwitch});
            }).catch(err2=>{
                console.log('JSON Error : '+err2.message);
            });
        }).catch(err=>{
            console.log('Update switch Error : '+err.message);
        });
    };

    clickOffHandler=(e)=>{
        console.log(e.target.value);
        fetch(`https://py-switches.herokuapp.com/graphql?query=mutation{UpdateSwitch(switchInput:{name:"${e.target.value}",state:${false},uuid:"${localStorage.getItem('uuid')}"}){
        name
        state
        }}`,{method: 'POST'}).then(fetchRsp=>{

            fetchRsp.json().then(jsnrsp=>{
                console.log(jsnrsp);
                this.setState({myAss:jsnrsp.data.UpdateSwitch});
            }).catch(err2=>{
                console.log('JSON Error : '+err2.message);
            });
        }).catch(err=>{
            console.log('Update switch Error : '+err.message);
        });
    };


    fetchData = () => {
        fetch(`https://py-switches.herokuapp.com/graphql?query={GetSwitches(uuid: "${localStorage.getItem('uuid')}"){name state}}`).then(re => {
            re.json().then(resp => {
                console.log(resp);
                this.setState({myAss:resp.data.GetSwitches});
            }).catch(eer => {
                console.log('JSON Error : ' + eer.message)
            })
            // updateMyAss(re);
        }).catch(ee => {
            console.log('Fetch Error : ' + ee.message);
        });
    };

    onAddClickHandler=()=>{
        fetch(`https://py-switches.herokuapp.com/graphql?query=mutation{CreateSwitch(switchInput:{name:"${this.state.newSwitchName}",state: false,uuid: "${localStorage.getItem('uuid')}"}){name}}
`,{method:'POST'}).then(re => {
           re.json().then(jsnr=>{
               if(jsnr.data.CreateSwitch){
                   this.fetchData();
               } else{
                   alert(`Switch can't be added`);
               }
           }).catch(errd=>{
               console.log('Add switch json error : '+errd.message);
           })

        }).catch(ee => {
            console.log('Fetch Error : ' + ee.message);
        });
    };

    switchName=(e)=>{
        this.setState({newSwitchName: e.target.value});
};
    render() {
        const styleOn=['btn btn-outline-primary'];
        const styleOnActive=['btn btn-outline-primary active'];
        const styleOff=['btn btn-outline-dark'];
        const styleOffActive=['btn btn-outline-dark active'];
        return(<div>
            <Navbar/>
            <input type='text' onChange={this.switchName} style={{'display':'inline'}} placeholder={'Add new switch'}/>
            <button className='btn btn-dark' onClick={this.onAddClickHandler}>Add</button>
            <table className='table table-bordered'>
            {
                this.state.myAss.map((ee,iid)=>{
                    return(<tbody key={iid}>
                    <tr>
                    <th scope="row">{ee.name}</th>
                        {
                            ee.state === "true" ? <td>
                                <button value={ee.name} className={styleOnActive} onClick={this.clickOnHandler}>ON</button>
                            </td>: <td><button value={ee.name} className={styleOn} onClick={this.clickOnHandler}>ON</button></td>
                        }
                        {
                            ee.state === "false" ? <td>
                                <button value={ee.name} className={styleOffActive} onClick={this.clickOffHandler}>OFF</button>
                            </td>: <td><button value={ee.name} className={styleOff} onClick={this.clickOffHandler}>OFF</button></td>
                        }
                    </tr>
                    </tbody>
                );
                })
            }
            </table>
        </div>);
    }
}


// export default function Switch() {
//     const fetchData=()=>{
//         fetch(`https://py-switches.herokuapp.com/graphql?query={GetSwitches(uuid: "${localStorage.getItem('uuid')}"){name state}}`).then(re=>{
//             re.json().then(resp=>{
//                 console.log(resp);
//                 updateMyAss(resp.data.GetSwitches);
//             }).catch(eer=>{
//                 console.log('JSON Error : '+eer.message)
//             })
//             // updateMyAss(re);
//         }).catch(ee=>{
//             console.log('Fetch Error : '+ee.message);
//         });
//     };
//
//     useEffect(()=>{
//         fetchData();
//     });
//     let [MyAss,updateMyAss] = useState([]);
//     return (<div>
//         {
//
//             MyAss.map((kk,iid)=>{
//                 return(<button key={iid}>{kk.name}</button>);
//             })
//         }
//     </div>);
// }